export default class CarrelloTestata{

    constructor(){}
}